module.exports = __webpack_public_path__ + "static/media/PingFangHK Light-01.4c9d3081.svg";